import { IconButton } from "./buttons/IconButton";

interface Props {
  file: File;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.KeyboardEvent<Element>) => void;
  className: string;
}

export default function SelectedFile(props: Props) {
  const file = props.file;

  return (
    <div
      className={`tw-mb-2 tw-grid tw-grid-cols-6 tw-rounded-md tw-border-[0.5px] tw-border-solid tw-border-gray-5 tw-bg-white tw-px-3 tw-py-2 ${props.className}`}
      title={file.name}
    >
      <span className="tw-col-span-4 tw-inline-flex tw-place-items-center tw-text-[14px] tw-font-bold">
        <i className="fa fa-circle-check tw-mr-2 tw-text-green-1" />{" "}
        <span className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
          {file.name}
        </span>
      </span>
      <span className="tw-col-span-2 tw-mb-2 tw-inline-flex tw-place-items-center tw-justify-end tw-pt-2 tw-text-[12px] tw-text-gray-3">
        {`${(file.size / 1048576).toFixed(1)} MB`}
        <IconButton
          className="tw-ml-3 tw-h-auto tw-w-auto tw-p-0 tw-text-[14px]"
          icon="fa fas fa-trash-can"
          onClick={props.onClick}
        />
      </span>
    </div>
  );
}
